import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const LocalHeader = () => {
  function checkUrl(query) {
    const classes = `nav-link ${
      window.location.pathname?.indexOf(query) === -1 ? "" : "active"
    }`;
    return classes;
  }
  const history = useHistory();
  return (
    <div class="row">
      <div class="tab-section">
        <div class="nav nav-tabs" id="nav-tab">
          <ul class="nav nav-tabs">
            <li>
              <button
                onClick={() => {
                  history.push("/settings/pos/ordrr-online/general");
                }}
                class={checkUrl("general")}
              >
                GENERAL
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  history.push("/settings/pos/ordrr-online/menu-sequencing");
                }}
                class={checkUrl("menu-sequencing")}
              >
                MENU &amp; SEQUENCING
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  history.push("/settings/pos/ordrr-online/delivery-partner");
                }}
                class={checkUrl("delivery-partner")}
              >
                DELIVERY PARTNERS
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LocalHeader;
